import {ValueObject} from '@s-ui/domain'

import {BooleanSharedValueObject} from '../../shared/ValueObjects/BooleanSharedValueObject.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class IsVehicleConfigurableValueObject extends ValueObject {
  #makeId
  #isConfigurable

  constructor({makeId, isConfigurable}) {
    super()
    this.#makeId = makeId
    this.#isConfigurable = isConfigurable
  }

  static createFromMakes({makesList, makeId}) {
    const parseMakeId = parseInt(makeId, 10)
    const isConfigurable = makesList.some(item => parseInt(item.value, 10) === parseMakeId)
    return IsVehicleConfigurableValueObject.create({
      makeId,
      isConfigurable
    })
  }

  static create({makeId, isConfigurable}) {
    return new IsVehicleConfigurableValueObject({
      makeId: StringSharedValueObject.createFromPrimitives({value: makeId}),
      isConfigurable: BooleanSharedValueObject.createWithoutEmptyValue({value: isConfigurable})
    })
  }

  get makeId() {
    return this.#makeId.value
  }

  get isConfigurable() {
    return this.#isConfigurable.value
  }

  get value() {
    return {
      makeId: this.makeId,
      isConfigurable: this.isConfigurable
    }
  }
}
